const ActorCard = ({actor})=>{
    return <div className="text-headline dark:text-headline-dark font-heading md:text-md text-xs min-h-[200px] text-center">
        <img alt="actor or actress" className="block mr-auto ml-auto rounded-full aspect-square object-cover max-h-[100px]  border-stroke" src={`https://image.tmdb.org/t/p/original${actor.profile_path}`}/>
        <h3>{actor.name}</h3>
        {
            (actor.character)?
            <>
            <h4 className="text-tertiary-dark">As</h4>
            <h3>{actor.character}</h3>
            </>
            :
            null
        }
    </div>
}

export default ActorCard